// extracted by mini-css-extract-plugin
module.exports = {"QuantityBox":"quantity_box_QuantityBox__2xSG8"};